import Functions from '@client/style/Functions';
import React from 'react';
import styled from 'styled-components';
import Image, { ImageData } from '../Image';
import HTML from '@client/core/utils/HTML';
import { Breakpoints, presetColors } from '@client/style/Variables';
import { TextStyle } from '@client/style/TextStyles';

const ImageText = styled.p`
	align-self: flex-start;
	margin-top: 10px;

	min-height: 1.2em;
	line-height: 1.2em;

	${TextStyle.size('small')}
	${TextStyle.family('title')}

	color: ${presetColors.blackish};
`;

const StyledImage = styled(Image)<{ $ratio: string }>`
	aspect-ratio: ${props => props.$ratio};
	height: auto;
	background-color: rgba(0, 0, 0, 0.2);

	width: ${props =>
		props.$ratio === '4/5'
			? 'min(calc(75vw - var(--gridGutter) * 4), 300px)'
			: 'min(calc(100vw - var(--gridGutter) * 4), 400px)'};

	${Functions.breakpoint(Breakpoints.laptop)} {
		width: ${props => (props.$ratio === '4/5' ? 'min(30vw, 450px)' : 'min(40vw, 600px)')};
	}

	${Functions.breakpoint(Breakpoints.largeDesktop)} {
		width: ${props => (props.$ratio === '4/5' ? 'min(23vw, 600px)' : 'min(30vw, 800px)')};
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export default function SimpleImageCarouselEntry({ image, text }: { image: ImageData; text: string }) {
	return (
		<>
			<StyledImage data={image} $ratio={Functions.findRatioSmall(image.width, image.height)}></StyledImage>
			<ImageText dangerouslySetInnerHTML={{ __html: HTML.clean(text) }} />
		</>
	);
}
